@if (isCallAsButtonDisplayed$ | async) {
  <div class="header-bar-quick-actions-divider"></div>
  @let isDisabled = isCallAsButtonDisabled$ | async;
  <button
    type="button"
    class="header-bar-trigger-button header-bar-quick-actions-call-as-button"
    [disabled]="isDisabled"
    (click)="openCallAsPopup()"
  >
    <i [nimbusIcon]="ICONS.PHONE"></i>
    <span class="header-bar-quick-actions-call-as-button-label">{{ TranslationKeys.GeneralCallOnBehalf | translate }}</span>
    @if (isDisabled) {
      <nimbus-tooltip
        [text]="TranslationKeys.CallAsNotEligible | translate"
        [ariaLabel]="TranslationKeys.CallAsNotEligible | translate"
      ></nimbus-tooltip>
    }
  </button>
}
